<template>
  <div class="func-query common-page">
    <a-breadcrumb>
      <a-breadcrumb-item>功能管理</a-breadcrumb-item>
      <a-breadcrumb-item>查询功能</a-breadcrumb-item>
    </a-breadcrumb>

    <section class="search-box">
      <a-select
        v-model="funcName"
        showSearch
        :showArrow="false"
        allowClear
        size="large"
        placeholder="功能名称"
        @change="searchSelectChange"
        style="width: 400px"
      >
        <a-select-option
          v-for="func in functions_select"
          :key="func.id"
          :value="func.name"
          optionFilterProp="label"
          >{{ func.name }}</a-select-option
        >
      </a-select>
      <a-button
        type="primary"
        size="large"
        @click="searchSelectChange(funcName)"
        >搜索</a-button
      >
    </section>

    <section class="search-result-number">
      <span>{{ functions.length }}个查询结果</span>
    </section>

    <section>
      <div class="common-box" v-for="func in functions" :key="func.id">
        <div class="common-box-body">
          <div class="common-box-body-title">
            <span>{{ func.name }}</span>
            <div>
              <a-button type="link" @click="toModify(func.id)">修改</a-button>
              <a-divider type="vertical" />
              <a-button type="link" @click="clickDelete(func.id)"
                >删除</a-button
              >
            </div>
          </div>

          <!-- key:value格式 -->
          <a-row>
            <a-col :span="6" class="key-value-col">
              <span>描述：</span>
              <span>{{ func.description }}</span>
            </a-col>
            <a-col :span="6" class="key-value-col">
              <span>英文描述：</span>
              <span>{{ func.descriptionEn }}</span>
            </a-col>
            <a-col :span="6" class="key-value-col">
              <span>code：</span>
              <span>{{ func.code }}</span>
            </a-col>
            <a-col :span="6" class="key-value-col">
              <span>算法：</span>
              <span>{{ func.algorithm }}</span>
            </a-col>
          </a-row>
        </div>
      </div>
    </section>

    <spin v-if="loading"></spin>
  </div>
</template>

<script>
import { queryFunctions, deleteFunction } from "../api/api";

export default {
  name: "func-query",

  data() {
    return {
      functions: [],
      functions_select: [],
      loading: false,
      funcName: undefined,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    toModify(id) {
      this.$router.push({
        name: "func-modify",
        query: {
          funcID: id,
        },
      });
    },

    clickDelete(id) {
      this.$confirm({
        title: "确定删除吗？",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk: () => {
          deleteFunction(id).then((res) => {
            if (res.error.code === 0) {
              this.$message.success("删除成功");
              this.fetchData();
            }
          });
        },
      });
    },

    fetchData() {
      this.loading = true;
      queryFunctions().then((res) => {
        if (res.error.code === 0) {
          this.functions = res.response ? res.response.functions : [];
          this.functions_select = res.response ? res.response.functions : [];
        }
        this.loading = false;
      });
    },

    // 搜索下拉框change事件
    searchSelectChange(funcName) {
      if (funcName === undefined) {
        this.functions = this.functions_select;
      } else {
        this.functions = this.functions_select.filter(
          (func) => func.name === funcName
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.func-query {
}
</style>